import axiosInstance from ".";

export const addReport = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/api/reports/addReport",
      payload,
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        success: false,
        message: error.message || "Connection failed",
      }
    );
  }
};

export const getAllAttempts = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/api/reports/getAllAttempts",
      payload,
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        success: false,
        message: error.message || "Connection failed",
      }
    );
  }
};

export const getAllAttemptsByUser = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/reports/getAllAttemptsByUser",
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        success: false,
        message: error.message || "Connection failed",
      }
    );
  }
};

export const getAllAttemptsByExam = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/api/reports/getAllAttemptsByExam",
      payload,
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        success: false,
        message: error.message || "Connection failed",
      }
    );
  }
};
